import { render, staticRenderFns } from "./DescargarResumenVentas.vue?vue&type=template&id=3eb8e0c8"
import script from "./DescargarResumenVentas.vue?vue&type=script&lang=js"
export * from "./DescargarResumenVentas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports